import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import MobileNavigation from '../../components/ui/MobileNavigation';
import ProfileInformationTab from './components/ProfileInformationTab';
import MessageTemplates from './components/MessageTemplates';
import SecurityTab from './components/SecurityTab';
import PreferencesTab from './components/PreferencesTab';
import ActivityTab from './components/ActivityTab';

const UserProfileSettings = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [isLoading, setIsLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');

  // Mock user data
  const mockUsers = {
    admin: {
      id: 1,
      name: "Sarah Johnson",
      email: "sarah.johnson@vendorhub.com",
      whatsappNumber: "+1 (555) 123-4567",
      role: "admin",
      profilePhoto: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
      businessName: "",
      businessAddress: "",
      preferences: {
        language: 'en',
        timezone: 'America/New_York',
        dateFormat: 'MM/DD/YYYY',
        currency: 'USD',
        theme: 'light',
        emailNotifications: true,
        whatsappNotifications: true,
        pushNotifications: false,
        marketingEmails: false,
        weeklyReports: true,
        dashboardLayout: 'default',
        itemsPerPage: 10,
        autoSave: true
      },
      twoFactorEnabled: true
    },
    vendor: {
      id: 2,
      name: "Michael Rodriguez",
      email: "michael.rodriguez@techsolutions.com",
      whatsappNumber: "+1 (555) 987-6543",
      role: "vendor",
      profilePhoto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
      businessName: "Tech Solutions Inc.",
      businessAddress: "123 Business Ave, New York, NY 10001",
      preferences: {
        language: 'en',
        timezone: 'America/New_York',
        dateFormat: 'MM/DD/YYYY',
        currency: 'USD',
        theme: 'light',
        emailNotifications: true,
        whatsappNotifications: true,
        pushNotifications: true,
        marketingEmails: true,
        weeklyReports: true,
        dashboardLayout: 'detailed',
        itemsPerPage: 25,
        autoSave: true,
        productAlerts: true,
        employeeReports: true
      },
      twoFactorEnabled: false
    },
    employee: {
      id: 3,
      name: "Emily Chen",
      email: "emily.chen@techsolutions.com",
      whatsappNumber: "+1 (555) 456-7890",
      role: "employee",
      profilePhoto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face",
      businessName: "",
      businessAddress: "",
      preferences: {
        language: 'en',
        timezone: 'America/New_York',
        dateFormat: 'MM/DD/YYYY',
        currency: 'USD',
        theme: 'auto',
        emailNotifications: true,
        whatsappNotifications: false,
        pushNotifications: false,
        marketingEmails: false,
        weeklyReports: false,
        dashboardLayout: 'compact',
        itemsPerPage: 10,
        autoSave: true,
        quickBilling: true,
        productShortcuts: true
      },
      twoFactorEnabled: false
    }
  };

  useEffect(() => {
    // Simulate loading and get user data
    const timer = setTimeout(() => {
      const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
      const userData = mockUsers[storedUser.role] || mockUsers.admin;
      setUser(storedUser);
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleMobileNavToggle = () => {
    setMobileNavOpen(!mobileNavOpen);
  };

  const handleUpdateProfile = (updatedData) => {
    setUser(prev => ({
      ...prev,
      ...updatedData
    }));
    
    // Update localStorage
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    localStorage.setItem('user', JSON.stringify({
      ...storedUser,
      ...updatedData
    }));
    
    setSuccessMessage('Profile updated successfully!');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleUpdateSecurity = (securityData) => {
    setUser(prev => ({
      ...prev,
      ...securityData
    }));
    
    setSuccessMessage('Security settings updated successfully!');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleUpdatePreferences = (preferences) => {
    setUser(prev => ({
      ...prev,
      preferences
    }));
    
    setSuccessMessage('Preferences saved successfully!');
    setTimeout(() => setSuccessMessage(''), 3000);
  };
  let tabs = [];

if (user?.role === 'vendor') {
  tabs = [
    {
      id: 'profile',
      label: 'Profile Information',
      icon: 'User',
      description: 'Manage your personal information'
    },
    {
      id: 'preferences',
      label: 'Preferences',
      icon: 'Settings',
      description: 'Customize your experience'
    }
  ];
} else {
  tabs = [
    {
      id: 'profile',
      label: 'Profile Information',
      icon: 'User',
      description: 'Manage your personal information'
    }
  ];
}

  // const tabs = [
  //   {
  //     id: 'profile',
  //     label: 'Profile Information',
  //     icon: 'User',
  //     description: 'Manage your personal information'
  //   },
  //   // {
  //   //   id: 'security',
  //   //   label: 'Security',
  //   //   icon: 'Shield',
  //   //   description: 'Password and security settings'
  //   // },
  //   {
  //     id: 'preferences',
  //     label: 'Preferences',
  //     icon: 'Settings',
  //     description: 'Customize your experience'
  //   },
  //   // {
  //   //   id: 'activity',
  //   //   label: 'Activity Log',
  //   //   icon: 'Activity',
  //   //   description: 'View your account activity'
  //   // }
  // ];

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header user={user} onSidebarToggle={handleSidebarToggle} sidebarCollapsed={sidebarCollapsed} />
        <Sidebar user={user} collapsed={sidebarCollapsed} onToggle={handleSidebarToggle} />
        <MobileNavigation user={user} isOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
        
        <main className={`pt-16 transition-all duration-200 ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60'}`}>
          <div className="p-6">
            <div className="flex items-center justify-center min-h-[400px]">
              <div className="text-center">
                <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-muted-foreground">Loading profile settings...</p>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Icon name="AlertCircle" size={48} className="text-destructive mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-foreground mb-2">Access Denied</h1>
          <p className="text-muted-foreground mb-4">Please log in to access profile settings.</p>
          <Button onClick={() => navigate('/whats-app-authentication')}>
            Go to Login
          </Button>
        </div>
      </div>
    );
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileInformationTab user={user} onUpdateProfile={handleUpdateProfile} />;
      // case 'security':
      //   return <SecurityTab user={user} onUpdateSecurity={handleUpdateSecurity} />;
      case 'preferences':
        return <MessageTemplates user={user}  />;
      // case 'activity':
      //   return <ActivityTab user={user} />;
      default:
        return <ProfileInformationTab user={user} onUpdateProfile={handleUpdateProfile} />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header user={user} onSidebarToggle={handleSidebarToggle} sidebarCollapsed={sidebarCollapsed} />
      <Sidebar user={user} collapsed={sidebarCollapsed} onToggle={handleSidebarToggle} />
      <MobileNavigation user={user} isOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      
      <main className={`pt-16 transition-all duration-200 ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60'}`}>
        <div className="p-6">
          {user && user.role === "vendor" && (  <Breadcrumb user={user} /> )}
          {user && user.role === "admin" && (  <Breadcrumb user={user} /> )}
         
          
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-foreground">Profile Settings</h1>
                <p className="text-muted-foreground mt-1">
                  Manage your account information, security, and preferences
                </p>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                  <Icon name="Settings" size={20} className="text-primary" />
                </div>
              </div>
            </div>
          </div>

          {/* Success Message */}
          {successMessage && (
            <div className="mb-6 bg-success/10 border border-success/20 rounded-lg p-4">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <p className="text-sm text-success font-medium">{successMessage}</p>
              </div>
            </div>
          )}

          {/* Settings Content */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            {/* Tab Navigation */}
            <div className="lg:col-span-1">
              <div className="bg-card border border-border rounded-lg p-4 sticky top-24">
                <nav className="space-y-2">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`w-full text-left p-3 rounded-md transition-colors micro-animation ${
                        activeTab === tab.id
                          ? 'bg-[#E3403B] text-primary-foreground'
                          : 'hover:bg-muted text-muted-foreground hover:text-foreground'
                      }`}
                    >
                      <div className="flex items-center space-x-3">
                        <Icon 
                          name={tab.icon} 
                          size={18} 
                          className={activeTab === tab.id ? 'text-primary-foreground' : 'text-muted-foreground'} 
                        />
                        <div className="flex-1 min-w-0">
                          <p className={`text-sm font-medium ${
                            activeTab === tab.id ? 'text-primary-foreground' : 'text-foreground'
                          }`}>
                            {tab.label}
                          </p>
                          <p className={`text-xs mt-1 ${
                            activeTab === tab.id ? 'text-primary-foreground/80' : 'text-muted-foreground'
                          }`}>
                            {tab.description}
                          </p>
                        </div>
                      </div>
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            {/* Tab Content */}
            <div className="lg:col-span-3">
              <div className="animate-fade-in">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default UserProfileSettings;